import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "document"
    }}>{`Document`}</h1>
    <p>{`Represents a single Photoshop document that is currently open
You can access instances of documents using one of these methods:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// The currently active document from the Photoshop object
const currentDocument = app.activeDocument

// Choose one of the open documents from the Photoshop object
const secondDocument = app.documents[1]

// You can also create an instance of a document via a UXP File entry
let fileEntry = require('uxp').storage.localFileSystem.getFileForOpening()
const newDocument = await app.open('/project.psd')
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "saveas"
    }}>{`saveAs`}</h3>
    <p>{`• `}<strong parentName="p">{`saveAs`}</strong>{`: `}<em parentName="p">{`object`}</em></p>
    <p>{`Save the document to a desired file type.`}</p>
    <p>{`For operations that require a UXP File token, use the UXP storage APIs to generate one.
See `}<a parentName="p" {...{
        "href": "https://www.adobe.com/go/ps-api-uxp-filesystemprovider"
      }}>{`https://www.adobe.com/go/ps-api-uxp-filesystemprovider`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`let entry = await require('uxp').storage.localFileSystem.getFileForSaving("target.psd");
document.saveAs.psd(entry);

// Save as a Copy (High JPG quality)
document.saveAs.jpg(entryJpg, { quality: 12 }, true);

// Save a PSB, with some options:
document.saveAs.psb(entryPsb, { embedColorProfile: true });

`}</code></pre>
    <h4 {...{
      "id": "type-declaration"
    }}>{`Type declaration`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bmp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`entry`}</inlineCode>{`: File, `}<inlineCode parentName="td">{`saveOptions?`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/saveoptions/bmpsaveoptions/"
            }}><em parentName="a">{`BMPSaveOptions`}</em></a>{`, `}<inlineCode parentName="td">{`asCopy`}</inlineCode>{`: `}<em parentName="td">{`boolean`}</em>{`) => `}<em parentName="td">{`Promise`}</em>{`<void`}{`>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`gif`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`entry`}</inlineCode>{`: File, `}<inlineCode parentName="td">{`saveOptions?`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/saveoptions/gifsaveoptions/"
            }}><em parentName="a">{`GIFSaveOptions`}</em></a>{`, `}<inlineCode parentName="td">{`asCopy`}</inlineCode>{`: `}<em parentName="td">{`boolean`}</em>{`) => `}<em parentName="td">{`Promise`}</em>{`<void`}{`>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`jpg`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`entry`}</inlineCode>{`: File, `}<inlineCode parentName="td">{`saveOptions?`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/saveoptions/jpegsaveoptions/"
            }}><em parentName="a">{`JPEGSaveOptions`}</em></a>{`, `}<inlineCode parentName="td">{`asCopy`}</inlineCode>{`: `}<em parentName="td">{`boolean`}</em>{`) => `}<em parentName="td">{`Promise`}</em>{`<void`}{`>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`png`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`entry`}</inlineCode>{`: File, `}<inlineCode parentName="td">{`saveOptions?`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/saveoptions/pngsaveoptions/"
            }}><em parentName="a">{`PNGSaveOptions`}</em></a>{`, `}<inlineCode parentName="td">{`asCopy`}</inlineCode>{`: `}<em parentName="td">{`boolean`}</em>{`) => `}<em parentName="td">{`Promise`}</em>{`<void`}{`>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`psb`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`entry`}</inlineCode>{`: File, `}<inlineCode parentName="td">{`saveOptions?`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/saveoptions/photoshopsaveoptions/"
            }}><em parentName="a">{`PhotoshopSaveOptions`}</em></a>{`, `}<inlineCode parentName="td">{`asCopy`}</inlineCode>{`: `}<em parentName="td">{`boolean`}</em>{`) => `}<em parentName="td">{`Promise`}</em>{`<void`}{`>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`psd`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`entry`}</inlineCode>{`: File, `}<inlineCode parentName="td">{`saveOptions?`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/saveoptions/photoshopsaveoptions/"
            }}><em parentName="a">{`PhotoshopSaveOptions`}</em></a>{`, `}<inlineCode parentName="td">{`asCopy`}</inlineCode>{`: `}<em parentName="td">{`boolean`}</em>{`) => `}<em parentName="td">{`Promise`}</em>{`<void`}{`>`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "properties-1"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`activeChannels`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/channel/"
            }}><em parentName="a">{`Channel`}</em></a>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Currently active channels of the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`activeHistoryBrushSource`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/historystate/"
            }}><em parentName="a">{`HistoryState`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The history state that history brush tool will use as its source`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`activeHistoryState`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/historystate/"
            }}><em parentName="a">{`HistoryState`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Currently active history state of the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`activeLayers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layers/"
            }}><em parentName="a">{`Layers`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The selected layers in the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`artboards`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layers/"
            }}><em parentName="a">{`Layers`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The artboards in the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`backgroundLayer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Background layer, if it exists`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bitsPerChannel`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#bitsperchanneltype"
            }}><em parentName="a">{`BitsPerChannelType`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The bits per color channel.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`channels`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/channels/"
            }}><em parentName="a">{`Channels`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`All channels in the document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cloudDocument`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This document is in the Adobe Creative Cloud.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cloudWorkAreaDirectory`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Local directory for this cloud document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`colorProfileName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the color profile.  Valid only when `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/#colorprofiletype"
            }}>{`colorProfileType`}</a>{` is `}{`\``}{`CUSTOM`}{`\``}{` or `}{`\``}{`WORKING`}{`\``}{`, returns `}{`"`}{`None`}{`"`}{` otherwise`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`colorProfileType`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#colorprofiletype"
            }}><em parentName="a">{`ColorProfileType`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether the document uses the working color profile, a custom profile, or no profile.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`compositeChannels`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/channel/"
            }}><em parentName="a">{`Channel`}</em></a>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Composite channels in the document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`guides`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/guides/"
            }}><em parentName="a">{`Guides`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Document`}{`'`}{`s height in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`histogram`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A histogram containing the number of pixels at each color intensity level for the composite channel. The array contains 256 members.  Valid only when `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/#mode"
            }}>{`mode`}</a>{` `}{`=`}{` `}{`\``}{`DocumentMode.{RGB,CMYK,INDEXEDCOLOR}`}{`\``}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`historyStates`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/historystates/"
            }}><em parentName="a">{`HistoryStates`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`History states of the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The internal ID of this document, valid as long as this document is open Can be used for batchPlay calls to refer to this document, used internally`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`layers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layers/"
            }}><em parentName="a">{`Layers`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`All the layers in the document at the top level`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`mode`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#documentmode"
            }}><em parentName="a">{`DocumentMode`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The color profile. To change it, please use `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/#changemode"
            }}>{`Document.changeMode`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name of the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Full file system path to this document, or the identifier if it is a cloud document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pathItems`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/pathitems/"
            }}><em parentName="a">{`PathItems`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The collection of paths in this document, currently shown in the Paths panel. `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/changelog/"
            }}><em parentName="a">{`Added in 23.3`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pixelAspectRatio`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The (custom) pixel aspect ratio to use`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`quickMaskMode`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The state of Quick Mask mode. If true, the app is in Quick Mask mode.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`resolution`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Document`}{`'`}{`s resolution (in pixels per inch)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`saved`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True if the document has been saved since the last change.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Document title`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced Document object`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Document`}{`'`}{`s width in pixels`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "changemode"
    }}>{`changeMode`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Changes the color profile of the document`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`mode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#changemode"
            }}><em parentName="a">{`ChangeMode`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/conversionoptions/bitmapconversionoptions/"
            }}><em parentName="a">{`BitmapConversionOptions`}</em></a>{` `}{`|`}{` `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/conversionoptions/indexedconversionoptions/"
            }}><em parentName="a">{`IndexedConversionOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "close"
    }}>{`close`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Closes the document, showing a prompt to save
unsaved changes if specified`}</p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`saveDialogOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#saveoptions"
            }}><em parentName="a">{`SaveOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "closewithoutsaving"
    }}>{`closeWithoutSaving`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Close the document, reverting all unsaved changes.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "convertprofile"
    }}>{`convertProfile`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Changes the color profile.`}</p>
    <p><inlineCode parentName="p">{`destinationProfile`}</inlineCode>{` must be either a string that names the color mode,
or one of these below, meaning of the working color spaces or Lab color.`}</p>
    <p><inlineCode parentName="p">{`"Working RGB", "Working CMYK", "Working Gray", "Lab Color"`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`destinationProfile`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`intent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#intent"
            }}><em parentName="a">{`Intent`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`blackPointCompensation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dither?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "createlayer"
    }}>{`createLayer`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Create a layer. See @CreateOptions`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const myEmptyLayer = await doc.createLayer()
const myLayer = await doc.createLayer({ name: "myLayer", opacity: 80, mode: "colorDodge" })
`}</code></pre>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/createoptions/layercreateoptions/"
            }}><em parentName="a">{`LayerCreateOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "createlayergroup"
    }}>{`createLayerGroup`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Create a layer group. See `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/objects/createoptions/grouplayercreateoptions/"
      }}>{`GroupLayerCreateOptions`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const myEmptyGroup = await doc.createLayerGroup()
const myGroup = await doc.createLayerGroup({ name: "myLayer", opacity: 80, mode: "colorDodge" })
const nonEmptyGroup = await doc.createLayerGroup({ name: "group", fromLayers: [layer1, layer2] })
`}</code></pre>
    <h4 {...{
      "id": "parameters-4"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/createoptions/grouplayercreateoptions/"
            }}><em parentName="a">{`GroupLayerCreateOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "crop"
    }}>{`crop`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Crops the document to given bounds`}</p>
    <h4 {...{
      "id": "parameters-5"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bounds`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/bounds/"
            }}><em parentName="a">{`Bounds`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`angle`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`height`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "duplicate"
    }}>{`duplicate`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/"
      }}><em parentName="a">{`Document`}</em></a>{`>`}</p>
    <p>{`Creates a duplicate of the document, making the duplicate active.`}</p>
    <p>{`The optional parameter `}<inlineCode parentName="p">{`name`}</inlineCode>{` provides the name for the duplicated document.`}</p>
    <p>{`The optional parameter `}<inlineCode parentName="p">{`mergeLayersOnly`}</inlineCode>{` indicates whether to only duplicate merged layers.`}</p>
    <h4 {...{
      "id": "parameters-6"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`mergeLayersOnly?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "duplicatelayers"
    }}>{`duplicateLayers`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`[]`}{`>`}</p>
    <p>{`Duplicates given layer(s), creating all copies above the top most one in layer stack,
and returns the newly created layers.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// duplicate some layers
const layerCopies = await document.duplicateLayers([layer1, layer3])
layerCopies.forEach((layer) => { layer.blendMode = 'multiply' })
// ...to another document
const finalDoc = await photoshop.open('~/path/to/collated/image.psd')
await document.duplicateLayers([logo1, textLayer1], finalDoc)
await finalDoc.close(SaveOptions.SAVECHANGES)
`}</code></pre>
    <h4 {...{
      "id": "parameters-7"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`layers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`targetDocument?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/"
            }}><em parentName="a">{`Document`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`if specified, duplicate to a different document target.`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "flatten"
    }}>{`flatten`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Flatten all layers in the document`}</p>
    <hr></hr>
    <h3 {...{
      "id": "grouplayers"
    }}>{`groupLayers`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Create a layer group from existing layers.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const layers = doc.layers
const group = await doc.groupLayers([layers[1], layers[2], layers[4]])
`}</code></pre>
    <h4 {...{
      "id": "parameters-8"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`layers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a>{`[]`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "linklayers"
    }}>{`linkLayers`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`[]`}</p>
    <p>{`Links layers together if possible, and returns a list of linked layers.`}</p>
    <h4 {...{
      "id": "parameters-9"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`layers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`array of layers to link together`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "mergevisiblelayers"
    }}>{`mergeVisibleLayers`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Merges all visible layers in the document into a single layer.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "paste"
    }}>{`paste`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Pastes the contents of the clipboard into the document. If the optional argument is
set to true and a selection is active, the contents are pasted into the selection.`}</p>
    <h4 {...{
      "id": "parameters-10"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`intoSelection?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "rasterizealllayers"
    }}>{`rasterizeAllLayers`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Rasterizes all layers.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "resizecanvas"
    }}>{`resizeCanvas`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Changes the size of the canvas, but does not change image size
To change the image size, see `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#resizeimage"
      }}>{`resizeImage`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// grow the canvas by 400px
let width = await document.width
let height = await document.height
await document.resizeCanvas(width + 400, height + 400)
`}</code></pre>
    <h4 {...{
      "id": "parameters-11"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value of new width in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`height`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value of new height in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`anchor?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#anchorposition"
            }}><em parentName="a">{`AnchorPosition`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Anchor point for resizing, by default will resize an equal amount on all sides.`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "resizeimage"
    }}>{`resizeImage`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Changes the size of the image`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await document.resizeImage(800, 600)
`}</code></pre>
    <h4 {...{
      "id": "parameters-12"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`width?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value of new width in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`height?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value of new height in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`resolution?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Image resolution in pixels per inch (ppi)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`resampleMethod?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#resamplemethod"
            }}><em parentName="a">{`ResampleMethod`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Method used during image interpolation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`amount?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value that controls the amount of noise value when using preserve details 0..100`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "revealall"
    }}>{`revealAll`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Expands the document to show clipped sections.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "rotate"
    }}>{`rotate`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Rotates the image clockwise in given angle, expanding canvas if necessary. (Previously rotateCanvas)`}</p>
    <h4 {...{
      "id": "parameters-13"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`angles`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "save"
    }}>{`save`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Performs a save of the document. The user will be presented with
a Save dialog if the file has yet to be saved on disk.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// To save a document in the current location
document.save()

// Shows the save dialog
unsavedDocument.save()
`}</code></pre>
    <hr></hr>
    <h3 {...{
      "id": "splitchannels"
    }}>{`splitChannels`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/"
      }}><em parentName="a">{`Document`}</em></a>{`[]`}{`>`}</p>
    <p>{`Splits the document channels into separate, single-channel
documents.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "suspendhistory"
    }}>{`suspendHistory`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Creates a single history state encapsulating everything that is done
in the callback, only for this document. All changes to the document should
be done in this callback.`}</p>
    <p>{`Note: If you make changes to any other document, those changes will
not be suspended in the same history state.`}</p>
    <p>{`The callback is passed in a SuspendHistoryContext object,
which contains the current document in a variable `}<inlineCode parentName="p">{`document`}</inlineCode>{`.`}</p>
    <p>{`For more info and advanced context, see `}<a parentName="p" {...{
        "href": "../media/executeAsModal"
      }}><inlineCode parentName="a">{`core.executeAsModal`}</inlineCode></a>{`
API, for which this API is a simple wrapper for.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`   require("photoshop").app.activeDocument.suspendHistory(async (context) => {
       // context.document is the \`app.activeDocument\`
       context.document.activeLayers[0].name = "Changed name";
   });
`}</code></pre>
    <h4 {...{
      "id": "parameters-14"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`callback`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`e`}</inlineCode>{`: SuspendHistoryContext) => `}<em parentName="td">{`void`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`historyStateName`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "trap"
    }}>{`trap`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Applies trapping to a CMYK document.`}</p>
    <p>{`Valid only when `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#mode"
      }}>{`Document.mode`}</a>{` is `}<inlineCode parentName="p">{`Constants.DocumentMode.CMYK`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-15"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "trim"
    }}>{`trim`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Trims the transparent area around the image on the specified sides of the canvas
base on trimType`}</p>
    <h4 {...{
      "id": "parameters-16"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`trimType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#trimtype"
            }}><em parentName="a">{`TrimType`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`top`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`left`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bottom`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`right`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      